import { Type } from '@sinclair/typebox';
import { createClientError } from '../core/create-client-error.js';
export const FileTooLargeError = createClientError('FILE_TOO_LARGE', Type.Object({
    maxMb: Type.Number(),
    uploadedMb: Type.Optional(Type.Number()),
}));
